import React from 'react';
import {_GPY,__GPYPost} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardTeamCardsSubstitue extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
	 	};
	}

	componentDidMount() {
	}


  render () {

    return (
			<>
			<div className="row">
					<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_substitution_card_title')}</strong></div>

					{this.props.substitution!==undefined&&this.props.substitution === true?
						<div className="col-3 p-1">
							<GpyToggleButton
							    condition={() => {return (this.props.scoreboard.playerCountByRole("HOME_TEAM_PLAYER,HOME_TEAM_SUBSTITUE, GUEST_TEAM_PLAYER,GUEST_TEAM_SUBSTITUE") === 2 )}}
									title={_GPY.i18n.get('gametype_' + this.props.scoreboard.getName() + '_scoreboard_substitution_card_button_substitution')}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {
										var pout = this.props.scoreboard.getHomeOrGuestPlayer();
										var pin = this.props.scoreboard.getHomeOrGuestSubstitutionPlayer();
										pin.vsRole = pin.vsRole.replace("_SUBSTITUE","_PLAYER");
										pout.vsRole = pout.vsRole.replace("_PLAYER","_SUBSTITUE");

										this.props.scoreboard.unselectPlayertLists();
										this.props.scoreboard.refreshPlayerLists();

										var m = this.props.scoreboard.getCurrentMainTime();
										var minF = (m/1000) / 60 ;
										var min = Math.floor(minF) ;
										var formatMin = "'"+('00'+min).slice(-2);

										__GPYPost("updatePlayerVsRole",{ gameId : this.props.scoreboard.state.currentGame.id , players : [pin,pout] } );

										var res = {visible: true,type:"SUBSTITUTION",
											team: this.props.scoreboard.getTeamByPlayer(pin),
											playerIn : _GPY.toPlayerName(pin),
											playerOut : _GPY.toPlayerName(pout),
											playerInId : pin.id ,
											playerOutId : pout.id ,
											minute : formatMin,
										}
										if(pin.__events===undefined){pin.__events=[];}
										pin.__events.push(res);
										if(pout.__events===undefined){pout.__events=[];}
										pout.__events.push(res);
										this.props.scoreboard.refreshPlayerLists();

										return res;
									}}
									scoreboard={this.props.scoreboard}
									getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
									stateName={this.props.scoreboard.getName()+"_button_substitution"}
									 />
					</div>
					:""}

					{this.props.cards!==undefined?this.props.cards.map((card)=>
						<div className="col-3 p-1">
					  	<GpyToggleButton condition={() => {return (this.props.scoreboard.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER")===1)}}
								title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_substitution_card_button_'+card)}
								onInit={() => {return {}}}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {
									var p = this.props.scoreboard.getHomeOrGuestPlayer();
									var m = this.props.scoreboard.getCurrentMainTime();
									var minF = (m/1000) / 60 ;
									var min = Math.floor(minF) ;
									var formatMin = "'"+('00'+min).slice(-2);

									var res = { visible: true, type: card + " CARD",
										player: p,
										playerFullName: _GPY.toPlayerName(p),
										team: this.props.scoreboard.getTeamByPlayer(p),
										message: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_substitution_card_message_'+card),
										minute : formatMin,
									};
									if(p.__events===undefined){p.__events=[];}
									p.__events.push(res);
									this.props.scoreboard.refreshPlayerLists();
									return res;
								}}
								scoreboard={this.props.scoreboard}
								getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
								stateName={this.props.scoreboard.getName()+"_button_card_"+card}
							/>
						</div>
					):""}

			</div>



		 </>
		);
  }

}
export default ScoreboardTeamCardsSubstitue;
